import { useMediaQuery } from 'react-responsive';
import theme from '@whitelabel/global-theme';
import { IXCMSImage } from './types';

interface IResponsiveBackgroundImageProps {
  backgroundImage?: IXCMSImage;
}

export const useResponsiveBackgroundImage = ({
  backgroundImage,
}: IResponsiveBackgroundImageProps): string | undefined => {
  const isMobile = !useMediaQuery({ minWidth: theme.gridBreakpoints.sm });
  const isTablet = useMediaQuery({ minWidth: theme.gridBreakpoints.sm, maxWidth: theme.gridBreakpoints.lg });

  if (isMobile && backgroundImage?.fileForMobile) {
    return backgroundImage.fileForMobile;
  }
  if (isTablet && backgroundImage?.fileForTablet) {
    return backgroundImage.fileForTablet;
  }
  return backgroundImage?.file;
};
